import React from "react";

import { useTranslation } from "utils";

import { Icon, Typography } from "components";

// Blue dashed teaser: "How much better could it be?" — shown on step 2 (replaces the adapted
// scenario card in the <5% lift variant).
export const HowMuchBetterBanner = () => {
  const { t } = useTranslation("scenarioAnalysis");

  return (
    <div className="onboarding-teaser" data-testid="onboarding-how-much-better">
      <span className="onboarding-teaser__icon">
        <Icon iconName="klim/plant-ai" size="l" />
      </span>
      <div className="onboarding-teaser__text">
        <Typography variant="paragraph-m">{t("onboarding.step2.teaser.title")}</Typography>
        <Typography variant="paragraph-s" color="grey-600">
          {t("onboarding.step2.teaser.description")}
        </Typography>
      </div>
    </div>
  );
};
